package com.mps.asc_app.data.places.model

import kotlinx.serialization.Serializable

@Serializable
data class PlaceDetailsResponse(
    val result: AddressDto? = null
)